export const aside = {
    step1: "Profil",
    step2: "Vérification",
    step3: "Partage"
}
